import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { UserProfileStore } from "../../states/user-profile/user-profile.store";
import { isAdminRole } from "../../utils/admin-role.util";

@Injectable({
    providedIn: 'root'
})
export class AdminOnlyGuard {

    private readonly userProfileStore = inject(UserProfileStore);
    private readonly router           = inject(Router);

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): true | UrlTree {
        return this.checkAdminRole();
    }

    canActivateChild(_childRoute: ActivatedRouteSnapshot, _state: RouterStateSnapshot): true | UrlTree {
        return this.checkAdminRole();
    }

    private checkAdminRole(): true | UrlTree {
        this.userProfileStore.rehydrateFromStorage();

        if (isAdminRole(this.userProfileStore.roleName())) {
            return true;
        }

        return this.router.createUrlTree(['/login']);
    }
}
